<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

.page-card {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}
.page-card .el-card__body {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 8;
  background: #fff;
  padding-top: 0;
}
.sticky-top::after {
  content: "";
  display: block;
  height: 8px;
  background: linear-gradient(to bottom, rgba(255,255,255,0.95), rgba(255,255,255,0));
}

</style>
